/** Switch MetaMask to the DAO chain when needed. */
export async function ensureCorrectChain(targetChainId) {
  if (!window.ethereum || targetChainId == null || targetChainId === '') return;
  const tid = Number(targetChainId);
  if (Number.isNaN(tid)) return;
  const hexChainId = `0x${tid.toString(16)}`;
  const current = await window.ethereum.request({ method: 'eth_chainId' });
  if (String(current).toLowerCase() === hexChainId.toLowerCase()) return;
  await window.ethereum.request({
    method: 'wallet_switchEthereumChain',
    params: [{ chainId: hexChainId }],
  });
}
